import { takeEvery } from "redux-saga/effects";
import * as TYPES from "./type";
import * as changeDeviceSaga from "./saga";

export function* watchChangeDeviceEdit() {
  yield takeEvery(TYPES.CHAGE_DEVICE_EDIT, changeDeviceSaga.changDeviceCurrentAction);
}

export function* watchChangeDeviceDelte() {
  yield takeEvery(TYPES.CHAGE_DEVICE_EDIT, changeDeviceSaga.changDeviceCurrentActionDelete);
}


